module.exports = __webpack_public_path__ + "media/images/about-logo-nmma-ef05297c840d9493a169836151369b2f.png";